export const SocketMessages = Object.freeze({
	DEPOSITS: "DEPOSITS",
	WITHDRAWALS: "WITHDRAWALS",
	TRANSFER: "TRANSFER",
	CONNECT: "connect",
	DISCONNECT: "disconnect",
});
